export enum CreationType {
	Simple = 0,
	Advanced = 1
}
